import {createApp} from "vue";
import ProductDetailsRx from "@/vue_components/praeparate/produktdetails-rx/ProductDetailsRx.vue";

document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('product-details-rx')
    if (!el) return

    const productId       = Number(el.dataset.productid)
    const praeparatId     = Number(el.dataset.praeparatid)
    // const hidePflichttext = el.dataset.hidepflichttext === 'true'

    createApp(ProductDetailsRx, { productId, praeparatId })
        .mount(el)
})